import { useState, type ReactNode } from 'react'
import { ContainerTabPanel } from '@/components/ContainerTabs'

/** Carrega o gerenciador no primeiro acesso e preserva o rascunho ao trocar de aba. */
export function CampaignEditorPersistentPanel({
  value,
  active,
  children,
}: {
  value: string
  active: boolean
  children: ReactNode
}) {
  const [visited, setVisited] = useState(active)
  if (active && !visited) setVisited(true)
  if (!active && !visited) return null
  return (
    <ContainerTabPanel value={value} keepMounted>
      {children}
    </ContainerTabPanel>
  )
}
